// extracted by mini-css-extract-plugin
export default {"confirmModal":"EditGroupModal_confirmModal__hcRaV"};